import type { ReactElement } from "react";

interface IInlineErrorSpanProps {
  children: string;
}

export default function InlineErrorSpan({ children, ...props }: IInlineErrorSpanProps): ReactElement {
  return (
    <span className="text-sm font-medium tracking-wide text-red-700 dark:text-red-300" {...props}>
      {children}
    </span>
  );
}
